<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <b-button variant="link" @click="showJobDetails = !showJobDetails">
          <b-icon small :icon="showHideIcon"></b-icon>
          {{showOrHide}} job details
        </b-button>
        <b-collapse id="jobDetails" :visible="showJobDetails">
          <b-card>
            <b-card-header>
              <b-card-text>Job Details</b-card-text>
            </b-card-header>
            <b-card-body>
              <b-row>
                <b-col cols="12" md="6">
                  <b-card-text>
                    <span class="font-weight-bold">Title:</span>
                    {{job.title}}
                  </b-card-text>
                </b-col>
                <b-col cols="12" md="6">
                  <b-card-text>
                    <span class="font-weight-bold">Position:</span>
                    {{job.position}}
                  </b-card-text>
                </b-col>
                <b-col cols="12" class="mt-3">
                  <b-card-text>
                    <span class="font-weight-bold">Description:<br/></span>
                    <div v-html="job.description"></div>
                  </b-card-text>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-collapse>
      </b-col>
      <b-col cols="12">
        <h2 class="text-center" v-if="job.published == null">Cannot view candidates until the job is published</h2>
        <b-tabs card v-else>
          <b-tab active>
            <template #title>
              Candidates <b-badge variant="primary" pill>{{candidates.length}}</b-badge>
            </template>
          <p
            class="text-muted"
          >Here's a list of candidates that matched your job criteria. You can review each candidate and decide who to send a screening to.</p>
            <b-list-group>
              <b-list-group-item
                class="flex-column align-items-start"
                v-for="(candidate, i) in candidates"
                :key="i"
                v-b-toggle="`candidateDetails${candidate.userNum}`"
              >
                <b-row>
                  <b-col cols="12" md="2">
                    <b-btn
                      variant="primary"
                      v-b-toggle="`candidateDetails${candidate.UserNum}`"
                    >
                      View
                    </b-btn>

                  </b-col>
                  <b-col cols="12" md="2">
                    <b-card-text>
                      <span class="text-muted">Candidate</span>
                      <br />
                      {{candidate.userNum}}
                    </b-card-text>
                  </b-col>
                  <b-col cols="2">
                    <b-card-text>
                      <span class="text-muted">Location</span>
                      <br />
                      {{candidate.location}}
                    </b-card-text>
                  </b-col>
                  <b-col cols="12" md="2">
                    <b-card-text>
                      <br />Skills Matched:
                      <b-badge variant="primary" pill>{{candidate.skillsMatched}}</b-badge>
                    </b-card-text>
                  </b-col>
                  <!-- <b-col cols="12" md="2">
                    <b-card-text>
                      <br />Certifications:
                      <b-badge variant="primary" pill>{{candidate.certifications}}</b-badge>
                    </b-card-text>
                  </b-col> -->
                  <b-col cols="12" md="2">
                    <b-btn
                      pill
                      variant="outline-primary"
                      class="mr-3"
                      :disabled="candidate.hasScreening"
                      title="Send this candidate a questionnaire"
                      @click="sendQuestionnaire(candidate, i)"
                    >
                      <b-icon-file-earmark-text font-scale="2" />
                    </b-btn>
                    <b-btn
                      pill
                      variant="outline-danger"
                      @click="removeCandidateFromList(candidate.uid, i)"
                      title="Remove candidate from list."
                    >
                      <b-icon-x font-scale="2" />
                    </b-btn>
                  </b-col>
                  <b-col cols="12" md="1">
                    <b-icon-chevron-down font-scale="2"></b-icon-chevron-down>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-collapse :id="`candidateDetails${candidate.userNum}`" accordion="candidate-list" role="tabpanel">
                      <b-row>
                        <b-col cols="12">
                          <b-card-body>
                            <b-card-text class="font-weight-bold text-muted">More Details:</b-card-text>
                          </b-card-body>
                        </b-col>
                        <b-col cols="12" md="6">
                          <b-card-body>
                            <b-card-text>
                              Skills:
                              <b-list-group>
                                <b-list-group-item v-for="(skill, j) in job.skills" :key="j">
                                  {{skill.name}}
                                  <b-badge variant="success" pill v-if="skillMatched(skill, candidate.skills)">matched</b-badge>
                                </b-list-group-item>
                              </b-list-group>
                            </b-card-text>
                          </b-card-body>
                        </b-col>
                        <b-col cols="12" md="6">
                          <b-card-body>
                            <span class="text-muted">Description:</span>
                            <b-card-text v-html="candidate.profileDesc"></b-card-text>
                          </b-card-body>
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab>
            <template #title>
                Screenings <b-badge v-if="numAvailableAnswers > 0" pill variant="primary">{{numAvailableAnswers}}</b-badge>
            </template>
            <p
              class="text-muted"
            >Candidates that have received a screening can be reviewed on this page. When they respond you will be notified and can review their answers and even request their resumé</p>
            <b-list-group>
              <p v-if="data.screenings.length < 1">You don't have any open screenings</p>
              <b-list-group-item
                v-else
                v-for="(screening,index) in questionnaires.filter(screening => !screening.status.rejected || (screening.status.rejected && !screening.rejection.companyAcknowledged))"
                :key="index+screening.uid"
                v-b-toggle="`screening${screening.uid}`"
              >
                <QuestionareItem :screening="screening" :job="job" :i="index" @updateCount="updateScreeningCount"></QuestionareItem>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab>
            <template #title>
              Resumés <b-badge v-if="resumeCount > 0" pill variant="primary">{{resumeCount}}</b-badge>
            </template>
            <p class="text-muted">
              Candidates whose resumé you've requested will appear here.
            </p>
            <b-list-group>
              <p v-if="resumes.length < 1">You don't have any resume requests yet.</p>
              <b-list-group-item
                v-else
                v-for="(screening,index) in resumes"
                :key="index+screening.uid"
                v-b-toggle="`screening${screening.uid}`"
              >
                <QuestionareItem :screening="screening" :resumes="true" :job="job"></QuestionareItem>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import User from '@/fstore/collections/User'
import Job from '@/fstore/collections/Job'
import Screening from '@/fstore/collections/Screening';
import QuestionareItem from '@/components/questionaires/QuestionaireItem_Company'

import _ from 'lodash';
//import {mapState} from 'vuex';

export default {
  name: 'CandidateList',
  components: {
    QuestionareItem
  },
  props: {
    job: {
      required: true
    }
  },
  data () {
    return {
      data: {
        screenings: [],
      },
      showJobDetails: true,
      numAvailableAnswers: 0,
      numAwaitingResponse: 0,
      candidates: [],
      questionnaires: [],
      resumes: [],
      resumeCount:0
    }
  },
  computed:{
    showOrHide() {
      return this.showJobDetails? "hide" : "show";
    },
    showHideIcon(){
      return this.showJobDetails? "chevron-up" : "chevron-down"
    }
  },
  async created () {
    this.$set(this.data, "screenings", await Screening.fetchScreeningsForJob(this.job.uid));
    this.candidates = (await User.getCandidatesForJob(this.job)).candidates.filter(candidate => (this.data.screenings.map(screening => screening.candidate.userNum)).indexOf(candidate.userNum) === -1);
    this.questionnaires = this.data.screenings.filter(screening => !screening.connectionRequest.sent && !screening.status.rejected);
    this.resumes =  this.data.screenings.filter(screening => screening.connectionRequest.sent && !screening.status.rejected);
    this.resumeCount = this.resumes.filter(resume => typeof(resume.connectionRequest.accepted) != "undefined").length;

    this.updateScreeningCount();
    this.numAwaitingResponse = this.data.screenings.filter(screening => !screening.connectionRequest.sent).length - this.numAvailableAnswers;
  },
  methods: {
    skillMatched(skill, candidateSkills) {      
      return candidateSkills.filter(c_skill => c_skill.name == skill.name).length > 0;
    },
    updateScreeningCount() {
      console.log("Updating screening count");
      this.numAvailableAnswers = this.data.screenings.filter(screening => !screening.connectionRequest.sent && screening.status.submitted && (!screening.status.rejected || (screening.status.rejected && !screening.rejection.companyAcknowledged))).length;
    },
    async sendQuestionnaire(candidate, index) {
      this.$store.dispatch('app/setOverlay', true);

      const screening = Screening.getTemplate();
      screening.jobRef = await Job.getRef(this.job.uid);
      screening.companyRef = this.job.company;
      screening.userRef = await User.getRef(candidate.uid);
      screening.sentBy = await User.getRef(this.$store.state.auth.data.uid);
      screening.questionnaire = this.job.questions;

     const response = await Screening.create(screening);

     if(response.errors.length) {
       this.$bvModal.msgBoxConfirm(`An error occurred while trying to send the candidate a screening. ${response.errors.join(', ')}`);
     }else {
       this.$bvModal.msgBoxConfirm("Questionnaire sent to candidate!");
       await this.$store.dispatch('screening/fetchAll', {jobId: this.job.uid});
       this.candidates.splice(index, 1);
     }

     this.$store.dispatch('app/setOverlay', false);
    },
    async removeCandidateFromList(userId, index) {

      const confirmed = await this.$bvModal.msgBoxConfirm('Are you sure you want to remove this candidate? Once a candidate has been removed, they cannot be retrieved for this job.', {
        title: 'Are you sure?',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Remove this candidate',
        cancelTitle: 'Cancel',
        cancelVariant: 'text',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      });

      if(confirmed) {
        this.$store.dispatch('app/setOverlay', true);
        this.job.removedCandidates.push(userId);
        await Job.update(this.job.uid, this.job);
        this.$store.dispatch('app/setOverlay', false);
        this.candidates.splice(index, 1);
      }
    }
  }
}
</script>